var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H23C24.1046 1 25 1.89543 25 3V15C25 16.1046 24.1046 17 23 17H3C1.89543 17 1 16.1046 1 15V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1973 12.9903H10.9141V5.34988H15.1973V12.9903Z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1883 9.16945C11.1883 7.61956 11.9194 6.23896 13.0579 5.34925C12.2254 4.69865 11.1746 4.31033 10.0326 4.31033C7.32917 4.31033 5.1377 6.4858 5.1377 9.16945C5.1377 11.8531 7.32917 14.0286 10.0326 14.0286C11.1746 14.0286 12.2254 13.6402 13.0579 12.9896C11.9194 12.0999 11.1883 10.7193 11.1883 9.16945Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9743 9.16945C20.9743 11.8531 18.7828 14.0286 16.0793 14.0286C14.9374 14.0286 13.8866 13.6402 13.0537 12.9896C14.1926 12.0999 14.9237 10.7193 14.9237 9.16945C14.9237 7.61956 14.1926 6.23896 13.0537 5.34925C13.8866 4.69865 14.9374 4.31033 16.0793 4.31033C18.7828 4.31033 20.9743 6.4858 20.9743 9.16945Z",
    fill: "#F79E1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H23V0H3V2ZM24 3V15H26V3H24ZM23 16H3V18H23V16ZM2 15V3H0V15H2ZM3 16C2.44772 16 2 15.5523 2 15H0C0 16.6569 1.34314 18 3 18V16ZM24 15C24 15.5523 23.5523 16 23 16V18C24.6569 18 26 16.6569 26 15H24ZM23 2C23.5523 2 24 2.44771 24 3H26C26 1.34315 24.6569 0 23 0V2ZM3 0C1.34315 0 0 1.34315 0 3H2C2 2.44772 2.44772 2 3 2V0Z",
    fill: "#E1DEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.9f82788db2d51843cb8a2919d1209d46.svg";
export { ForwardRef as ReactComponent };